import {
    defineStore,
} from 'pinia';
import {
    computed,
    reactive, toRefs,
} from 'vue';
import {
    createAdaptedFile,
} from '../utils/AdaptedFile';

export const useAttachmentStore = defineStore('profile-attachments', () => {
    const state = reactive({
        attachments: [],
    });

    function updateFromQuery(data) {
        state.attachments = data.map(file => createAdaptedFile(file));
    }

    const count = computed(() => state.attachments.length);

    return {
        ...toRefs(state),
        updateFromQuery,
        count,
    };
});
